/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandy_Vivid_Wren_RaceInputs */

const en_sandy_vivid_wren_race = /** @type {(inputs: Sandy_Vivid_Wren_RaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No comment attributes selected`)
};

const de_sandy_vivid_wren_race = /** @type {(inputs: Sandy_Vivid_Wren_RaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Kommentarmerkmale ausgewählt`)
};

/**
* | output |
* | --- |
* | "No comment attributes selected" |
*
* @param {Sandy_Vivid_Wren_RaceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sandy_vivid_wren_race = /** @type {((inputs?: Sandy_Vivid_Wren_RaceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandy_Vivid_Wren_RaceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sandy_vivid_wren_race(inputs)
	return de_sandy_vivid_wren_race(inputs)
});